import React from "react";
import { FormattedMessage } from "react-intl";
import styled from "@emotion/styled";
import { useAuth, useLinks } from "hooks";
import { Link } from "components/Links";
import { Row } from "components/Containers";
import { BUTTON_SIZE, PrimaryButton } from "components/Buttons";
import { breakpoints, fontSize } from "style";
import { NAV_WIDTH } from "components/Nav/SideNav";
import { ProfileLink } from "components/Profile";

/**
 * Impersonating
 */
const Impersonating = (props) => {
  const { isImpersonating, trueUser, memberRole, ...me } = useAuth();
  const links = useLinks();

  if (!isImpersonating) return null;

  const profile = {
    firstName: me?.firstName,
    lastName: me?.lastName,
    avatarUrl: me?.avatarUrl,
    ...me?.profile,
  };

  const href = `${links.stop_impersonating}${profile?.slug ? `?profile=${profile.slug}` : ""}`;

  return (
    <Container offset={NAV_WIDTH} {...props}>
      <div>
        <FormattedMessage
          id="Global.Impersonating"
          values={{
            impersonator: <User>{trueUser?.name}</User>,
            impersonatee: <ProfileLink profile={profile} withOverlay />,
            role: <Role>{memberRole}</Role>,
          }}
        />
      </div>
      <Link to={href}>
        <PrimaryButton size={BUTTON_SIZE.small} href={href}>
          <FormattedMessage id="Global.StopImpersonating" />
        </PrimaryButton>
      </Link>
    </Container>
  );
};

const Role = styled.span`
  font-size: ${fontSize.xxsmall};
  padding: 0.25rem 0.5rem;
  border-radius: 0.6rem;
  border: 1px rgba(0, 0, 0, 0.1) solid;
`;

const Container = styled(Row)`
  background: rgba(255, 255, 255, 0.5);
  backdrop-filter: blur(10px);
  position: fixed;
  bottom: 3rem;
  border-radius: 4rem;
  z-index: 10;
  padding: 1rem 2rem;
  box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.1);
  left: calc(50% + ${({ offset }) => parseInt(offset) / 2}rem);
  transform: translate(-50%, 0);
  flex-wrap: nowrap;
  width: fit-content;
  max-width: 100%;
  text-align: center;
  align-items: center;
  justify-content: center;

  @media (max-width: ${breakpoints.tablet}) {
    left: 50%;
  }

  @media (max-width: ${breakpoints.mobile}) {
    flex-direction: column;
    border-radius: 1rem;
    padding: 2rem;
  }
`;

const User = styled.span`
  font-weight: 600;
`;

export default Impersonating;
